export function mobileLineupsIsActive({ taxonomyOpen, leftPanelTab, showLineupsFocus, generatedLineups }) {
  const generatorPanelOpen = taxonomyOpen === true && leftPanelTab === "lineup";
  const lineupResultsOpen = showLineupsFocus === true && (generatedLineups?.length || 0) > 0;
  return generatorPanelOpen || lineupResultsOpen;
}
